import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./language-switcher";
import {useMemo} from "react";
import {useDetectLanguage} from "../helpers/language-detector";
import { useState, useEffect, useRef, useLayoutEffect } from "react";

const footerItems = [
    { id: "home", url: "" },
    { id: "news", url: "/news" },
    { id: "contact", url: "/contact" },
    // { id: "donate", url: "/donate" },
];

export default function Navbar() {
    const { t } = useTranslation();
    const lang = useDetectLanguage();
    const year = useMemo(() => new Date().getFullYear(), []);

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-links">
                    <div className="footer-content-title">
                        <h2>{t(`footer.useful-links.label`)}</h2>
                    </div>
                    <div className="useful-links">
                        {
                            footerItems.map((item, i) => {
                                return <a href={`${item.url}/?lang=${lang}`} className="footer-link" key={i}>{t(`footer.useful-links.${item.id}`)}</a>
                            })
                        }
                    </div>
                </div>
                <div className="footer-contact">
                    <div className="footer-content-title">
                        <h2>{t(`footer.contact.label`)}</h2>
                    </div>
                    <div className="contact-details">
                        <p><b>{t(`footer.contact.address`)}: </b>412 Philmont Ave, Feasterville, PA 19053</p>
                        <p><b>{t(`footer.contact.telephone`)}: </b>[ Phone Number ]</p>
                        <p><b>{t(`footer.contact.email`)}: </b>[ Email Address ]</p>
                    </div>
                </div>
                <div className="footer-media">
                    <div className="footer-content-title">
                        <h2>{t(`footer.social-media.label`)}</h2>
                    </div>
                    <div className="media-details">
                        <a href="https://www.facebook.com/profile.php?id=100064567997597" target="_blank">
                            <div className="media-icon" id="facebook">
                                <i className="bi bi-facebook"></i>
                            </div>
                        </a>
                        <a href="https://www.instagram.com/gaocna/" target="_blank">
                            <div className="media-icon" id="instagram">
                                <i className="bi bi-instagram"></i>
                            </div>
                        </a>
                        <a href="https://www.youtube.com/@georgianapostolicorthodoxc342/featured" target="_blank">
                            <div className="media-icon" id="youtube">
                                <i className="bi bi-youtube"></i>
                            </div>
                        </a>
                    </div>
                    <div className="page-logo">
                        <p>{t(`footer.social-media.web-developer`)}: <a href="https://www.andriaberi.com" target="_blank"><strong>{t(`footer.social-media.developer-name`)}</strong></a></p>
                    </div>
                </div>
            </div>
            <div className="footer-legal">
                <p>{t(`footer.copyright.gaocna`)} {year} &copy; {t(`footer.copyright.rights`)}</p>
            </div>
        </footer>
    )
}
